<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Distance') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group languageversioned">
            <label for="name">{{ _('Name') }}</label>
            <input class="form-control" type="text" id="distanceName" v-model="distance.name" :placeholder="_('Enter a name for the distance')" /> 
          </div>
          <div class="form-group languageversioned">
            <label for="description">{{ _('Description') }}</label> 
            <textarea id="distanceDescription" class="form-control" v-model="distance.description" rows="8" wrap="virtual" :placeholder="_('Enter a description for the distance')"></textarea>
          </div>
          <div class="form-group">
            <label for="distance">{{ _('Distance') }}</label> 
            <div class="input-group">
              <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" v-model="distance.distance" id="distanceDistance" />
              <div class="input-group-btn">
                <Dropdown buttonClass="btn-default" menuClass="dropdown-menu-right" :teleport="true">
                  <template #trigger>
                    {{ _(distance.unit || 'km') }} <span class="caret"></span>
                  </template>
                  <li><a href="javascript:;" data-value="km" v-on:click="distance.unit = 'km'">{{ _('km') }}</a></li>
                  <li><a href="javascript:;" data-value="m" v-on:click="distance.unit = 'm'">{{ _('m') }}</a></li>
                </Dropdown>
              </div>
            </div>
          </div>
        </div> 
      </div> 
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i> {{ _('Close') }}</button>
      <button type="button" class="btn btn-success" v-on:click="save" :disabled="!isValid"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
      <button type="button" class="btn btn-danger pull-left" v-on:click="remove"><i class="fa fa-trash fa-fw"></i>{{ _('Delete') }}</button>
    </div>
  </div> 
</template>

<script>
import { mapGetters } from 'vuex'
import formats from '~/lib/formats'

export default {
  data () {
    return {
      distance: {}
    }
  },
  props: ['selectedDistance'],
  mixins: [formats],
  computed: {
    ...mapGetters(['locale']),
    shortLocale () {
      return this.locale.split('_')[0]
    },
    isValid() {
      return this.distance && this.distance.name && this.distance.distance && this.distance.unit
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    save () {
      this.$emit('save', this.distance)
    },
    remove () {
      this.$emit('remove', this.distance)
    }
  },
  created() {
    if (this.selectedDistance) {
      this.distance = Object.assign({}, this.selectedDistance)
    }
  }
}  

</script>